import "./index.scss";

export const CheckoutSubmit = ({ handleSubmit }) => {
  return (
    <div className="checkout-submit">
      <button className="order-summary-submit" onClick={handleSubmit}>
        Submit Order
      </button>
      <p className="submit-transaction-info">Your transaction is secured.</p>
    </div>
  );
};
